// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { PayorType } from './payorType.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PayorSaveModel {
    'payorName'?: string;
    'payorType'?: PayorType;
    'payorBin'?: string;
    'payorPcn'?: string;
    'payorGroup'?: string;
    'isPlaceholder'?: boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PayorSaveModel>> = [
        {
            "name":     "payorName",
            "baseName": "payorName",
            "type":     "string"
        },
        {
            "name":     "payorType",
            "baseName": "payorType",
            "type":     "PayorType"
        },
        {
            "name":     "payorBin",
            "baseName": "payorBin",
            "type":     "string"
        },
        {
            "name":     "payorPcn",
            "baseName": "payorPcn",
            "type":     "string"
        },
        {
            "name":     "payorGroup",
            "baseName": "payorGroup",
            "type":     "string"
        },
        {
            "name":     "isPlaceholder",
            "baseName": "isPlaceholder",
            "type":     "boolean"
        },
    ];

    static getAttributeTypeMap() {
        return PayorSaveModel.attributeTypeMap;
    }
}
